import { useMutation } from "@tanstack/react-query";
import { checkSyncSurveysWithTemplate, UseSyncSurveysWithTemplateProps } from ".";

export function useCheckSyncSurveysWithTemplate({
  surveyTemplateId,
}: UseSyncSurveysWithTemplateProps) {
  return useMutation({
    mutationKey: ["survey", "sync", "check", surveyTemplateId],
    mutationFn: checkSyncSurveysWithTemplate,
  });
}
